import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { AuthContextType, AuthState, RequestTokenResponse, VerifyTokenResponse, DirectAuthResponse } from '../types/auth.types';

/**
 * Hook personnalisé pour accéder au contexte d'authentification
 * @returns Contexte d'authentification avec l'état et les méthodes
 */
export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  
  if (context === undefined) {
    throw new Error('useAuth doit être utilisé à l\'intérieur d\'un AuthProvider');
  }
  
  return context;
};
